/**
 * "5 mins", or nothing at all when the read time is unknown.
 *
 * The api sends `null` deliberately for a read time it could not resolve — a
 * playlist made entirely of external links carries no minutes, and the search
 * handler falls back to null rather than inventing a zero.
 *
 * `null >= 0` is true in JavaScript, because null converts to 0 in a relational
 * comparison, so the obvious guard let it through and cards rendered the string
 * "null mins" beside the clock. Returning undefined lets a caller drop the
 * clock and its separator entirely.
 *
 * Zero says nothing a reader can use either, so it gets the same treatment. The
 * playlist info bar has always hidden a zero (`detail/info/info-bar`), and a
 * playlist created a moment ago carries one until content is added to it — the
 * landing slice fills the gap with `readTime ?? 0`.
 *
 * `> 0` is what makes both cases fall out of a single comparison: null and
 * undefined are not greater than zero, and neither is NaN.
 *
 * @param {Number|null|undefined} readTime Minutes, or null when unknown
 * @returns {String|undefined} The label, or undefined when there is nothing to say
 */
export const formatReadTime = readTime => {
  if (!(readTime > 0)) return undefined

  return `${readTime} mins`
}
